import { render, staticRenderFns } from "./ResultFormSiTd.vue?vue&type=template&id=2356fb7e&scoped=true&"
import script from "./ResultFormSiTd.vue?vue&type=script&lang=js&"
export * from "./ResultFormSiTd.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormSiTd.vue?vue&type=style&index=0&id=2356fb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356fb7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2356fb7e')) {
      api.createRecord('2356fb7e', component.options)
    } else {
      api.reload('2356fb7e', component.options)
    }
    module.hot.accept("./ResultFormSiTd.vue?vue&type=template&id=2356fb7e&scoped=true&", function () {
      api.rerender('2356fb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSiTd.vue"
export default component.exports